<h2 mat-dialog-title class="cut-long-text">Medium auswählen</h2>

<mat-divider></mat-divider>

<div class="searchRow">
  <pixl-free-filter-input [matIcon]="'search'" [hint]="getSearchFilterHint()" [minLength]="freeFilterLen"
    (onKeyUpChange)="setFreeFilter($event)" />
  &nbsp;
  <pixl-competency-cb (onStateChange)="setCompetencyFilter($event)" />
  &nbsp;
  <pixl-state-cb (onStateChange)="setStateFilter($event)" [withEmptyOption]="true" [initValue]="getInitOption()" />
</div>

<mat-divider></mat-divider>

<mat-dialog-content class="mat-typography">
  <div class="main-table">
    <div class="table-container mat-elevation-z4">
      <table mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)">

        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef>Aktion</th>
          <td mat-cell *matCellDef="let asset; let idx = index">
            <button mat-icon-button aria-label="Edit" (click)="takeAsset(idx)" matTooltip="Medium übernehmen">
              <mat-icon>add_shopping_cart</mat-icon>
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
          <td mat-cell *matCellDef="let asset">{{ asset.name }}</td>
        </ng-container>

        <ng-container matColumnDef="tags">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Tags</th>
          <td mat-cell *matCellDef="let asset">
            @if(asset.tags) {
            @for (tag of asset.tags; track tag) {
            <button type="button" class="button-tag">{{ tag }}</button>
            &nbsp;
            }
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="image">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Vorschau</th>
          <td mat-cell *matCellDef="let asset">
            <img src="{{ getImageUrl(asset)}}" alt="" width="30px" height="30px" />
          </td>
        </ng-container>

        <ng-container matColumnDef="audio">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Anhören</th>
          <td mat-cell *matCellDef="let asset">
            <audio #mobileAudioCtrl controls preload="auto" class="audio-control">
              <source src="{{ getAudioUrl(asset) }}" type="audio/mpeg">
              Your browser does not support the audio element.
            </audio>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: columnsToDisplay"></tr>
      </table>

      <pixl-main-pagination [pageChangeCallback]="paginationChanged"></pixl-main-pagination>
    </div>
  </div>
</mat-dialog-content>

<mat-divider></mat-divider>

<mat-dialog-actions>
  <button mat-raised-button (click)="onCancel()">Abbruch</button>
</mat-dialog-actions>